import React from 'react';
import Orders from './Orders';

function OrdersProcessing() {
  return <Orders status="processing" />;
}

export default OrdersProcessing;
